module.exports = __webpack_public_path__ + "img/instr_2.bea0ce2f.svg";